import { ComponentProps } from 'react';
import { Platform, Pressable } from 'react-native';
import { useTranslation } from 'react-i18next';
import { generateUsername } from 'friendly-username-generator';

import { Input } from '../Input';
import RefreshIcon from './refresh.svg';
import { UserIcon } from '../../assets/icons';
import { withTranslation } from '../../locales/hoc';

interface Props extends ComponentProps<typeof Input> {
	showGenerator?: boolean;
}

const UserNameFieldComponent = ({
	placeholder,
	onChangeText,
	showGenerator,
	...inputProps
}: Props) => {
	const { t } = useTranslation();

	const handleGenerateUsername = () => {
		const randomUsername = generateUsername().replace('-', '_');

		onChangeText && onChangeText(randomUsername);
	};

	const label = placeholder || t('common.username');
	const accessoryRight = showGenerator ? (
		<GenerateButton onPress={handleGenerateUsername} />
	) : undefined;

	return (
		<Input
			textContentType="username"
			placeholder={label}
			{...(Platform.OS === 'web' ? { label } : { accessoryLeft: <UserIcon /> })}
			accessoryRight={accessoryRight}
			onChangeText={onChangeText}
			secureTextEntry={Platform.OS === 'android' ? true : false}
			keyboardType={Platform.OS === 'android' ? 'visible-password' : undefined}
			autoCapitalize="none"
			{...inputProps}
		/>
	);
};

const GenerateButton = ({ onPress }: { onPress: () => void }) => (
	<Pressable testID="generate-username-button" onPress={onPress}>
		<RefreshIcon width={28} height={28} opacity={0.5} />
	</Pressable>
);

export const UserNameField = withTranslation(UserNameFieldComponent);
